<p [innerHtml]="text()" style="display: inline"></p>
@if (!isLast()) {
@if (!mobileMode()) {
<span style="white-space: nowrap">
  {{ lastWord()
  }}<input class="input" [(ngModel)]="currentValue" (input)="onInputChange()" (focus)="focusInput()" (blur)="onBlur()"
    [style.border-bottom]="'1px solid ' + clozeTestStyleModel().specialCharacterListColor"
    #answer="ngModel" /></span>
} @else {
<!-- Mobile input doesn't trigger soft keyboard -->
<span style="white-space: nowrap; line-height: 1rem">
  {{ lastWord() }}
  <!--eslint-disable-next-line-->
  <span [tabIndex]="0" class="input-mobile"
    [ngClass]="{ 'input-empty': !currentValue }"
    [style.border-bottom]="'1px solid ' + clozeTestStyleModel().specialCharacterListColor"
    [style.background-color]="isActiveInput() ? clozeTestStyleModel().specialCharacterListDisabledColor : ''"
    (keyup.enter)="focusInput()"
    (click)="focusInput()">
    <cloze-test-exercise-input-field [inputText]="currentValue" [inputNumber]="nr()" [answer]="currentAnswer()">
    </cloze-test-exercise-input-field>
  </span>
</span>
}
}